import React, { Component } from "react";
import "./style.scss";
import { ROOT, HOST_URL } from "../../constants";
import { stringify } from "qs";
import { Translation } from "react-i18next";
import { SliderNavigation } from "../Slider";

export class Similar extends Component {
  element = null;
  able = true;

  state = {
    similarProducts: []
  };

  componentDidMount() {
    this.getSimilarProducts();
  }

  getSimilarProducts = async () => {
    const url = window.location.pathname;
    const cbu = url.substring(url.lastIndexOf("/") + 1);
    try {
      const response = await fetch(
        `${HOST_URL}/shopping/v1/compositions/similars/insider/channelCatalogItems?channelCatalogItemCode=${cbu}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json"
          },
          credentials: "include"
        }
      );
      if (response.ok) {
        const result = await response.json();
        this.setState({
          similarProducts: result
        });
      } else {
        window.logApiErrors(
          "r",
          "getSimilarProducts",
          response.status,
          response.statusText
        );
        throw new Error("GET_SIMILAR_PRODUCT_FAILED");
      }
    } catch (error) {
      console.error(error);
    }
  };

  handleCard = (e, data, index) => {
    // 取消<a>預設值行為
    e.preventDefault();

    // 等待0.5秒後執行換頁;
    const url = e.target.href;
    setTimeout(() => {
      window.location = url;
    }, 500);
  };

  render() {
    const { similarProducts } = this.state;

    return (
      <div>
        {similarProducts.length > 0 && (
          <>
            <div
              className="sectionTitle-wrap"
              ref={element => {
                this.element = element;
              }}
            >
              <p className="sectionTitle">
                <Translation>
                  {t => <>{t("section.similarItems")}</>}
                </Translation>
              </p>
            </div>
            <SliderNavigation
              name="similars_wrap"
              recentlyViewed={similarProducts}
            >
              {similarProducts.map((data, index) => (
                <div
                  className="swiper-slide"
                  key={index}
                  data-scarabitem={data.cciId}
                >
                  <div className="pdt_block">
                    <a
                      className="pdtImg_link"
                      href={`${ROOT}${data.productDetailUrl}`}
                      style={{
                        backgroundImage: `url(${data.imageUrl})`
                      }}
                      onClick={e => {
                        this.handleCard(e, data, index);
                      }}
                    >
                      <div
                        className="pdtImghover_container"
                        style={{
                          backgroundImage: `url(${data.imageUrl2})`
                        }}
                      />
                    </a>
                    <div className="desc_wrap">
                      <div className="collectionName">{data.name}</div>
                      <div className="name">{data.name2}</div>
                      {data.saleType &&
                      [
                        "normal",
                        "display-show-price",
                        "display-inventory"
                      ].includes(data.saleType) ? (
                        data.price !== data.originalPrice ? (
                          <React.Fragment>
                            <div
                              className="product-orignal-price"
                              style={{ fontSize: "12px" }}
                            >
                              {data.originalPrice}
                            </div>
                            <div className="price">{data.price}</div>
                          </React.Fragment>
                        ) : (
                          <div className="price">{data.originalPrice}</div>
                        )
                      ) : data.saleType === "display" ? null : null}
                    </div>
                  </div>
                </div>
              ))}
            </SliderNavigation>
          </>
        )}
      </div>
    );
  }
}

export default Similar;
